import URLS from '@/server/urls';
import { POST } from '@/server/http';

export default async ({
    search = '',
    limit = -1,
} = {}, options = { showError: true }) => {
    const [ content, error, status ] = await POST(URLS.das.project.getList, {
        search,
        limit,
    }, options);
    if (error) return { error, status };
    return content || { rows: [] };
};
